export const ADD_NEW_MESSAGE = "ADD_NEW_MESSAGE";
export const READ_NEW_MESSAGE = "READ_NEW_MESSAGE";
export const ADD_NEW_MESSAGE_SUCCESS_IN_CHAT_LIST =
  "ADD_NEW_MESSAGE_SUCCESS_IN_CHAT_LIST";
export const GET_CONVERSATION = "GET_CONVERSATION";
export const GET_CONVERSATION_SUCCESS = "GET_CONVERSATION_SUCCESS";
export const CLEAR_CHAT_MESSAGES = "CLEAR_CHAT_MESSAGES";
export const UPLOAD_FILE = "UPLOAD_FILE";
export const UPLOAD_FILE_SUCCESS = "UPLOAD_FILE_SUCCESS";
export const UPLOAD_FILE_ERROR = "UPLOAD_FILE_ERROR";
export const DELETE_FILE = "DELETE_FILE";
export const DELETE_FILE_SUCCESS = "DELETE_FILE_SUCCESS";
export const DELETE_FILE_ERROR = "DELETE_FILE_ERROR";
export const RESET_FILE_UPLOAD = "RESET_FILE_UPLOAD";
export const SHOW_TYPING_INDICATOR = "SHOW_TYPING_INDICATOR";
export const HIDE_TYPING_INDICATOR = "HIDE_TYPING_INDICATOR";
